class CardVariantPicker extends HTMLElement {
  constructor() {
    super();

    this.addToCart = this.querySelector('add-to-cart');
    this.selects = Array.from(this.querySelectorAll('[data-option-index] select'));
    this.addToCartLabel = this.addToCart.querySelector('.card-variant-picker__label');

    this.container = this.closest('.product-card-wrapper') || this;
    this.priceWrapper = this.container.querySelector('.price');
    if (this.priceWrapper) {
      this.priceRegular = this.priceWrapper.querySelector('.price__regular .price-item--regular');
      this.priceCompare = this.priceWrapper.querySelector('.price__sale .price-item--regular');
      this.priceSale = this.priceWrapper.querySelector('.price__sale .price-item--sale');
    }

    this.addEventListener('change', this.onVariantChange.bind(this));
    this.updateMasterId();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  onVariantChange() {
    this.updateMasterId();
  }

  updateMasterId() {
    const options = this.selects.map((select) => select.value);

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => option === options[index]).includes(false);
    });

    this.updateAddToCart();
    this.updatePrice();
  }

  updatePrice() {
    const variant = this.currentVariant;
    if (!variant || !this.priceWrapper || typeof theme === 'undefined' || !theme.Currency) return;

    this.priceWrapper.classList.remove('price--sold-out', 'price--on-sale');

    if (variant.available == false) {
      this.priceWrapper.classList.add('price--sold-out');
    } else if (variant.compare_at_price > variant.price) {
      this.priceWrapper.classList.add('price--on-sale');
    }

    if (this.priceRegular) {
      this.priceRegular.innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.price, window.shopSettings.moneyFormat) + '</bdi></price-money>';
    }

    if (variant.compare_at_price > variant.price) {
      if (this.priceCompare) {
        this.priceCompare.innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.compare_at_price, window.shopSettings.moneyFormat) + '</bdi></price-money>';
      }
      if (this.priceSale) {
        this.priceSale.innerHTML = '<price-money><bdi>' + theme.Currency.formatMoney(variant.price, window.shopSettings.moneyFormat) + '</bdi></price-money>';
      }
    }
  }

  updateAddToCart() {
    if (!this.currentVariant) {
      this.addToCart.setAttribute('disabled', true);
      this.addToCart.removeAttribute('data-variant-id');
      return;
    }

    this.addToCart.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant.available) {
      this.addToCart.removeAttribute('disabled');
      this.addToCart.classList.remove('button--soldout');
      if (this.addToCartLabel) this.addToCartLabel.textContent = this.addToCartLabel.dataset.addToCartLabel;
    }
    else {
      this.addToCart.setAttribute('disabled', true);
      this.addToCart.classList.add('button--soldout');
      if (this.addToCartLabel) this.addToCartLabel.textContent = this.addToCartLabel.dataset.soldOutLabel;
    }
  }
}
customElements.define('card-variant-picker', CardVariantPicker);
